const bankImage = (file) => (file ? `/banks/${file}` : "");

export const VENEZUELAN_BANKS = [
  { id: "bdv", name: "Banco de Venezuela", code: "0102", domain: "bancodevenezuela.com", image: bankImage("bdv.png") },
  // { id: "bvc", name: "Banco Venezolano de Crédito", code: "0104", domain: "venezolano.com", image: bankImage("bvc.png") },
  { id: "mercantil", name: "Banco Mercantil", code: "0105", domain: "mercantilbanco.com", image: bankImage("mercantil.png") },
  // { id: "provincial", name: "BBVA Provincial", code: "0108", domain: "provincial.com", image: bankImage("provincial.png") },
  // { id: "bancaribe", name: "Bancaribe", code: "0114", domain: "www.bancaribe.com.ve", image: bankImage("bancaribe.png") },
  // { id: "exterior", name: "Banco Exterior", code: "0115", domain: "bancoexterior.com", image: bankImage("exterior.png") },
  // { id: "caroni", name: "Banco Caroní", code: "0128", domain: "bancocaroni.com.ve", image: bankImage("caroni.png") },
  { id: "banesco", name: "Banesco", code: "0134", domain: "www.banesco.com", image: bankImage("banesco.png") },
  // { id: "sofitasa", name: "Banco Sofitasa", code: "0137", domain: "sofitasa.com", image: bankImage("sofitasa.png") },
  // { id: "plaza", name: "Banco Plaza", code: "0138", domain: "www.bancoplaza.com", image: bankImage("plaza.png") },
  // { id: "bangente", name: "Bangente", code: "0146", domain: "bangente.com.ve", image: bankImage("bangente.png") },
  // { id: "bfc", name: "Banco Fondo Común", code: "0151", domain: "bfc.com.ve", image: bankImage("bfc.png") },
  // { id: "cien-banco", name: "100% Banco", code: "0156", domain: "100x100banco.com", image: bankImage("cien-banco.png") },
  // { id: "delsur", name: "DelSur Banco Universal", code: "0157", domain: "delsur.com.ve", image: bankImage("delsur.png") },
  // { id: "tesoro", name: "Banco del Tesoro", code: "0163", domain: "www.bt.com.ve", image: bankImage("tesoro.png") },
  // { id: "agricola", name: "Banco Agrícola de Venezuela", code: "0166", domain: "bavenlinea.com.ve", image: "" },
  // { id: "bancrecer", name: "Bancrecer", code: "0168", domain: "www.bancrecer.com.ve", image: bankImage("bancrecer.png") },
  // { id: "r4", name: "Banco R4", code: "0169", domain: "r4conecta.io", image: bankImage("r4.png") },
  // { id: "activo", name: "Banco Activo", code: "0171", domain: "www.bancoactivo.com", image: bankImage("activo.png") },
  { id: "bancamiga", name: "Bancamiga", code: "0172", domain: "bancamiga.com", image: bankImage("bancamiga.png") },
  // { id: "bid", name: "Banco Internacional de Desarrollo", code: "0173", domain: "bid.com.ve", image: bankImage("bid.png") },
  // { id: "banplus", name: "Banplus", code: "0174", domain: "banplus.com", image: bankImage("banplus.png") },
  // { id: "bicentenario", name: "Banco Bicentenario", code: "0175", domain: "bicentenariobu.com", image: bankImage("bicentenario.png") },
  // { id: "banfanb", name: "BANFANB", code: "0177", domain: "www.banfanb.com.ve", image: bankImage("banfanb.png") },
  // { id: "n58", name: "N58 Banco Digital", code: "0178", domain: "n58bancodigital.com", image: bankImage("n58.png") },
  // { id: "bnc", name: "Banco Nacional de Crédito", code: "0191", domain: "bnc.com.ve", image: bankImage("bnc.png") },
];

export const getBankById = (id) =>
  VENEZUELAN_BANKS.find((bank) => bank.id === id) || null;

/** Pago móvil o transferencia requieren indicar el banco. */
export const paymentMethodRequiresBank = (methodName) => {
  const normalized = String(methodName || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "");
  return (
    normalized.includes("pagomovil") ||
    normalized.includes("transferencia")
  );
};

export const resolveBankLabel = (bank) => {
  if (!bank) return "";
  if (typeof bank === "string") {
    return getBankById(bank)?.name || bank;
  }
  return bank.name || getBankById(bank.id)?.name || "";
};

export const resolveBankImage = (bank) => {
  if (!bank) return "";
  if (typeof bank === "string") return getBankById(bank)?.image || "";
  if (bank.image) return bank.image;
  return getBankById(bank.id)?.image || "";
};
